import {
  BigTextInput,
  DateMMDDYYYY,
  FieldShell,
  HeightFtIn,
} from './FieldPrimitives';

const PatientInfoSection = ({ responses, setField, errors }) => {
  return (
    <div className="space-y-6">
      <p className="text-base md:text-lg text-gray-700">
        Tell us a little about yourself. We use this to register you with the
        state if you are approved.
      </p>

      <DateMMDDYYYY
        value={responses.date_of_birth}
        onChange={(v) => setField('date_of_birth', v)}
        error={errors.date_of_birth}
      />

      <FieldShell
        label="Gender"
        htmlFor="gender"
        help="Select what best applies. You can leave blank if you prefer not to say."
      >
        <select
          id="gender"
          value={responses.gender || ''}
          onChange={(e) => setField('gender', e.target.value)}
          className="block w-full px-4 border border-gray-300 rounded-lg text-mmj-header focus:outline-none focus:ring-2 focus:ring-mmj-blue focus:border-mmj-blue"
          style={{ minHeight: '56px', fontSize: '18px' }}
        >
          <option value="">Prefer not to say</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      </FieldShell>

      <FieldShell
        label="Street address"
        htmlFor="address"
        required
        help="The address on your government-issued ID."
        error={errors.address}
      >
        <BigTextInput
          id="address"
          value={responses.address}
          onChange={(v) => setField('address', v)}
          autoComplete="street-address"
          maxLength={120}
          required
          ariaInvalid={!!errors.address}
        />
      </FieldShell>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FieldShell label="City" htmlFor="city" required error={errors.city}>
          <BigTextInput
            id="city"
            value={responses.city}
            onChange={(v) => setField('city', v)}
            autoComplete="address-level2"
            maxLength={60}
            required
            ariaInvalid={!!errors.city}
          />
        </FieldShell>

        <FieldShell
          label="ZIP code"
          htmlFor="zip"
          required
          help="5 digits."
          error={errors.zip}
        >
          <BigTextInput
            id="zip"
            value={responses.zip}
            onChange={(v) => setField('zip', v.replace(/\D/g, '').slice(0, 5))}
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={5}
            autoComplete="postal-code"
            required
            ariaInvalid={!!errors.zip}
          />
        </FieldShell>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <HeightFtIn
          feet={responses.height_ft}
          inches={responses.height_in}
          onFeetChange={(v) => setField('height_ft', v)}
          onInchesChange={(v) => setField('height_in', v)}
          error={errors.height}
        />
        <FieldShell
          label="Weight"
          htmlFor="weight_lbs"
          required
          help="Pounds. Example: 180."
          error={errors.weight_lbs}
        >
          <BigTextInput
            id="weight_lbs"
            value={responses.weight_lbs}
            onChange={(v) =>
              setField('weight_lbs', v.replace(/\D/g, '').slice(0, 3))
            }
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={3}
            suffix="lbs"
            required
            ariaInvalid={!!errors.weight_lbs}
          />
        </FieldShell>
      </div>
    </div>
  );
};

export default PatientInfoSection;
